import { Api } from "../ApiConfig";

export const migrate = async (): Promise<void> => {
    const url = `/api/Migration/Migrate`;
    await Api.post(url);
}